<template>
  <div class="card px-4 pt-2 pb-4">
    <!-- <div class="row">
      <div class="col-3"></div>
      <div class="col-9">
        <h3 class="">Автор</h3>
      </div>
    </div>
    <div class="row">
      <div class="col-3 d-flex justify-content-center">
        <img
          v-if="user.mainhpoto != ''"
          :src="user.mainphoto"
          class="shadow author-card__image"
          style=""
          alt=""
        />
        <img
          v-else
          src="/images/no_avatar.png"
          class="shadow author-card__image"
          style="
          "
          alt=""
        />
      </div>
      <div class="col-9">
        <p class="m-0">
          <router-link :to="{ name: 'user_show', params: { id: user.id } }">{{
            user.fullname
          }}</router-link>
        </p>
        <p>{{ user.description }}</p>
        <p class="m-0">
          <span style="font-weight: bold; font-size: 80%"
            >Всего курсов у Автора:</span
          >
          {{ user.coursesCount }}
        </p>
      </div>
    </div> -->

    <h3 class="">Автор</h3>
        <div class="row d-flex">          
            <div class="col-12 d-flex">
    <!-- <img src="/images/teacher.svg" style="width: 30px; float: left; " alt=""> -->
    <img v-if="user.mainhpoto != ''" :src="user.mainphoto" class="shadow" style="padding: 3px; width: 90px; height: 90px; float: left; border-radius: 50%; border: 2px solid #243B53; " alt="">
                <img v-else src="/images/no_avatar.png" class="shadow" style="padding: 3px; width: 90px; height: 90px; float: left; border-radius: 50%; border: 2px solid #243B53; " alt="">
                <div class="ml-3">
                    <p class="m-0"><router-link :to="{ name: 'user_show', params: { id: user.id } }">{{ user.fullname }}</router-link></p>
                    <p>{{ user.description }}</p>
                    <p class="m-0"><span style="font-weight: bold; font-size: 80%;">Всего курсов у Автора:</span> {{ user.coursesCount }}</p>
                </div>                    
            </div>
            <!-- <div class="col-12 mt-3">
                {{ user.description }}
            </div> -->
        </div>
  </div>
</template>
<script>
export default {
  props: {
    user: Object,
  },
};
</script>

<style scoped>
.author-card__image {
  padding: 3px;
  width: 80px;
  height: 80px;
  object-fit: cover;
  border-radius: 50%;
  border: 2px solid #243b53;
}
</style>